import React from 'react'
import ReactDOM from 'react-dom'
import leaflet from 'leaflet'
import { sweref99Tm, fromLatLngToSweref99Tm } from './sweref99Tm'
import { MapContextProvider } from './mapContext'
import { debounce } from 'throttle-debounce'
import { FocusWithin } from '../Accessibility/FocusWithin'

export default class LeafletMap extends React.Component {

	map = undefined

	componentDidMount() {
		const mapDomElement = ReactDOM.findDOMNode(this)
		const extentChangeEventHandler = this.onExtentChange.bind(this)
 		this.map = leaflet.map(mapDomElement, { 
 			crs: sweref99Tm,
 			zoomControl: false,
 			attributionControl: false,
 			maxZoom: sweref99Tm.options.resolutions.length - 1,
 		})
    	this.map.on('moveend', extentChangeEventHandler)
    	this.map.on('resize', debounce(500, extentChangeEventHandler))
		this.updateView()
		setTimeout(this.forceUpdate.bind(this), 0)
 	}

 	updateView() {
 		this.map.setView(this.props.center, this.props.zoom)
 	}

	onExtentChange() {
	    if (this.props.onExtentChange && this.map) {
		    const bounds = this.map.getBounds()
		    const center = this.map.getCenter()
		    const [east, north] = fromLatLngToSweref99Tm(bounds.getNorthEast())
		    const [west, south] = fromLatLngToSweref99Tm(bounds.getSouthWest())
		    this.props.onExtentChange({
		        bounds: { north, east, south, west },
		    	view: {
		    		center: [center.lat, center.lng],
		    		zoom: this.map.getZoom()
		    	}
		    })
		}
	}

	hasMapViewChanged() {
		const mapZoom = this.map.getZoom()
		const mapCenter = this.map.getCenter()
		return this.props.zoom !== mapZoom
			|| this.props.center[0] !== mapCenter.lat
			|| this.props.center[1] !== mapCenter.lng
	}

	componentDidUpdate() {
		if (this.hasMapViewChanged()) {
			// If-satsen förhindrar en oändlig loop som krashar webbläsaren.
			this.updateView()
		}
	}

	componentWillUnmount() {
		this.map.remove()
		this.map = undefined
	}

	render() {
		return (
			<FocusWithin>
				{({ focusProps, isFocused }) => (
					<div {...focusProps} style={{ border: isFocused ? '3px solid black' : '3px solid rgba(255,255,255,.5)', height: '100%' }}>
						{this.map
							? (
								<MapContextProvider value={this.map}>
									{this.props.children}
								</MapContextProvider>
							) : null
						}
					</div>
				)}
			</FocusWithin>
		)
	}

}



// WEBPACK FOOTER //
// ./src/components/Leaflet/Map.js